import { connect } from 'react-redux'

import CheckoutCoupon from './CheckoutCoupon'
import { addCouponAsync, removeCouponAsync, updateCouponsAsync } from './couponActionCreators'

const mapCheckoutCouponStateToProps = (state) => {
    return {
        Coupons: state.entities.Coupons,
        show: state.constants.allowCoupons && !!!state.ui.onPaymentScreen,
        isExpanded: false,
        isRequired: false,
        toolTip: state.constants.partnerIdTooltip
    };
}

const mapCheckoutCouponDispatchToProps = (dispatch) => {
    return {
        onAddCoupon: (code) => (dispatch(addCouponAsync({ code }))),
        onRemoveCoupon: (code) => (dispatch(removeCouponAsync({ code }))),
        updateCoupons: () => dispatch(updateCouponsAsync())
    }
}

const CheckoutCouponContainer = connect(mapCheckoutCouponStateToProps, mapCheckoutCouponDispatchToProps)(CheckoutCoupon);

export default CheckoutCouponContainer